module.exports = __webpack_public_path__ + "static/media/voice_to_sign.25a14489.svg";